export default {
  Password: "Password",
  Microsoft:"Microsoft",
  Okta: "Okta"
}
